<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-text-input__block-header">
      <label class="common-text-input__label-no-cursor">
        <span class="common-text-input__text-label">{{fieldTypeFile.titleField}}</span>
        @if (field.required) {
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if(field.description) {
            <tooltip-info [description]="field.description"
            [field]="field"></tooltip-info>
          }
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
          @if (field.relatedInfo?.length) {
            <button class="common-button__icon-sm-noborder"
              pTooltip="{{'common.related-info'| afTranslate}}"
              tooltipPosition="top"
              (click)="openModalRelatedInfo(field.relatedInfo, $event)">
              <i class="lf-icon-search-text common-icon__md"></i>
            </button>
          }
          @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
            <tooltip-in-report [inReport]="fieldTypeFile.inReport"></tooltip-in-report>
          }
        </div>
      </label>
      <div class="common-text-input__buttons-right-header">
        <button class="common-button__icon-sm-noborder"
          (click)="addDocuments()"
          [disabled]="field.noEditable">
          <i class="lf-icon-up-file common-icon__md"></i>
        </button>
      </div>
    </div>
    <div class="common-text-file__block-list-values">
      @for (document of fieldTypeFile.field.evaluatedValue?.documents; track $index) {
        <div class="common-text-input__block-input"
          [ngClass]="{'common-text-input__block-input--with-value': !field.noEditable}">
          <div class="common-text-input__input overflow-hidden">
            <button class="common-button__link overflow-hidden"
              [disabled]="(!concept?.conceptObjectId || field.noEditable)"
              (click)="downloadFile(document)">
              <span-tooltip class="common-button__link-text"
                [text]="document.name"></span-tooltip>
            </button>
          </div>
          @if (document.canBeDeleted && !field.noEditable) {
            <button class="common-text-input__icon-clean-input"
              (click)="removeDocument(document)">
              <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
            }
        </div>
      }
    </div>
  </div>
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
    </div>
  }
</div>
